import { createClassComponent } from 'lib/preactHelpers'

import Dropdown from 'components/Dropdown'
import './index.sass'

const DropdownAsHeader = createClassComponent('DropdownAsHeader', Dropdown)
export default DropdownAsHeader
